// import { FieldType } from '@ngx-formly/core';
import { ComponentType } from '@angular/cdk/portal';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  MatCalendarCellClassFunction,
  MatDatepicker,
} from '@angular/material/datepicker';
import {
  FieldTypeConfig,
  FormlyConfig,
  ɵobserve as observe,
} from '@ngx-formly/core';
import { FieldType, FormlyFieldProps } from '@ngx-formly/material/form-field';

interface DaterangepickerProps extends FormlyFieldProps {
  datepickerOptions?: Partial<{
    touchUi: boolean;
    opened: boolean;
    disabled: boolean;
    startView: 'month' | 'year' | 'multi-year';
    datepickerTogglePosition: 'suffix' | 'prefix';
    calendarHeaderComponent: ComponentType<any>;
    filter: (date: any | null) => boolean;
    min: any;
    max: any;
    dateInput: (
      field: FieldTypeConfig<DaterangepickerProps>,
      event: any
    ) => void;
    dateChange: (
      field: FieldTypeConfig<DaterangepickerProps>,
      event: any
    ) => void;

    monthSelected: (
      field: FieldTypeConfig<DaterangepickerProps>,
      event: any,
      picker: MatDatepicker<any>
    ) => void;
    yearSelected: (
      field: FieldTypeConfig<DaterangepickerProps>,
      event: any,
      picker: MatDatepicker<any>
    ) => void;

    dateClass: MatCalendarCellClassFunction<any>;
    panelClass: string | string[];
    startAt: any | null;
  }>;
}

@Component({
  selector: 'lockton-apps-date-range-picker-type',
  templateUrl: './date-range-picker-type.component.html',
  styleUrls: ['./date-range-picker-type.component.scss'],
  standalone: false,
})
export class DateRangePickerTypeComponent
  extends FieldType<FieldTypeConfig<DaterangepickerProps>>
  implements AfterViewInit, OnDestroy
{
  @ViewChild('datepickerToggle', { static: true })
  datepickerToggle!: TemplateRef<any>;
  // startField!: FieldTypeConfig<DatepickerProps>;
  override defaultOptions = {
    props: {
      datepickerOptions: {
        startView: 'month' as const,
        datepickerTogglePosition: 'suffix' as const,
        disabled: false,
        opened: false,
        dateInput: () => {},
        dateChange: (x: any) => {
          console.log(x);
        },
        monthSelected: () => {},
        yearSelected: () => {},
      },
    },
  };

  private fieldErrorsObserver!: ReturnType<typeof observe>;

  get formGroup() {
    return this.field.formControl as unknown as FormGroup;
  }

  constructor(private config: FormlyConfig, private cdRef: ChangeDetectorRef) {
    super();
  }

  detectChanges() {
    this.options.detectChanges?.(this.field);
  }

  ngAfterViewInit() {
    this.props.suffix = this.datepickerToggle;

    this.props[
      this.props.datepickerOptions?.datepickerTogglePosition || 'suffix'
    ] = this.datepickerToggle;

    observe<boolean>(
      this.field,
      ['props', 'datepickerOptions', 'opened'],
      () => {
        this.cdRef.detectChanges();
      }
    );
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
    this.fieldErrorsObserver?.unsubscribe();
  }
}
